// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d9e1f6f","663":"30b614f6","732":"a748284d"}[chunkId] + ".chunk.js";
};